import React, { useState } from 'react';
import './css/Contact.css'; // Dedicated page styles

// Reusing your standalone, modular layout components
import Navbar from './components/Navbar';
import Newsletter from './components/NewsLetter';
import Footer from './components/Footer';

// Reusing your global hero and banner background assets
import contactHeroBg from '../images/HomeBgBanner.png';
import DownloadApp from './components/DownloadApp';

function Contact() {
    // Optional form state handling for future interactivity
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission logic here
        console.log('Form submitted:', formData);
    };

    return (
        <div className="contact-page-wrapper">

            {/* 1. Header Hero Section with integrated clean Navbar */}
            <section
                className="contact-hero-section"
                style={{ backgroundImage: `url(${contactHeroBg})` }}
            >
                <Navbar />
            </section>

            {/* 2. Contact Section Core Layout */}
            <section className="contact-main-section">
                <div className="container">

                    {/* Centralized Section Header */}
                    <div className="row justify-content-center text-center mb-5">
                        <div className="col-lg-8">

                            <span className="contact-section-mini-tag">
                                Get In Touch
                            </span>

                            <h2 className="contact-section-heading">
                                Let's Make Your Home Services Easier
                            </h2>

                            <p className="contact-section-subtext mt-3">
                                Need a reliable professional for your home? Whether you need
                                cleaning, plumbing, electrical, appliance, painting, carpentry,
                                or pest control services, Fixovera is here to help.
                            </p>

                            <div className="zigzag-border mx-auto mt-3"></div>

                        </div>
                    </div>

                    <div className="row g-5 justify-content-center">

                        {/* Left Column: Contact Form */}
                        <div className="col-lg-7">
                            <div className="contact-glass-form-card">
                                <form onSubmit={handleSubmit}>
                                    <div className="row g-4">

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="form-label-custom">Your Name</label>
                                                <input
                                                    type="text"
                                                    name="name"
                                                    className="form-control custom-input-field"
                                                    placeholder="John Doe"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className="form-label-custom">Email Address</label>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    className="form-control custom-input-field"
                                                    placeholder="john@example.com"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="form-group">
                                                <label className="form-label-custom">Subject</label>
                                                <input
                                                    type="text"
                                                    name="subject"
                                                    className="form-control custom-input-field"
                                                    placeholder="Project Inquiry / Modular Integration"
                                                    value={formData.subject}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="form-group">
                                                <label className="form-label-custom">Your Message</label>
                                                <textarea
                                                    name="message"
                                                    rows="5"
                                                    className="form-control custom-input-field"
                                                    placeholder="Tell us about your project requirements..."
                                                    value={formData.message}
                                                    onChange={handleChange}
                                                    required
                                                ></textarea>
                                            </div>
                                        </div>

                                        <div className="col-12 text-end">
                                            <button type="submit" className="contact-submit-btn">
                                                Send Message
                                            </button>
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>

                        {/* Right Column: Direct Info / Branding Panel */}
                        <div className="col-lg-4">
                            <div className="contact-info-glass-card">

                                <h3>Contact Information</h3>

                                <div className="zigzag-border mb-4"></div>

                                <ul className="contact-details-list">

                                    {/* Registered Office */}
                                    <li>
                                        <span className="info-label">
                                            Registered Office:
                                        </span>

                                        <span className="info-value">
                                            Singur,<br />
                                            West Bengal, India
                                        </span>
                                    </li>


                                    {/* Operating Office */}
                                    <li>
                                        <span className="info-label">
                                            Operating Office:
                                        </span>

                                        <span className="info-value">
                                            Tobacco House,<br />
                                            Lalbazar,<br />
                                            Kolkata, West Bengal, India
                                        </span>
                                    </li>


                                    {/* Direct Email */}
                                    <li>
                                        <span className="info-label">
                                            Direct Email:
                                        </span>

                                        <span className="info-value">
                                            info@fixovera.com
                                        </span>
                                    </li>


                                    {/* Direct Phone */}
                                    <li>
                                        <span className="info-label">
                                            Direct Phone:
                                        </span>

                                        <span className="info-value">

                                            <a
                                                href="tel:+916290425024"
                                                style={{
                                                    color: "inherit",
                                                    textDecoration: "none"
                                                }}
                                            >
                                                +91 6290 425 024
                                            </a>

                                        </span>
                                    </li>

                                </ul>

                            </div>
                        </div>

                    </div>

                </div>
            </section>

            {/* Download App Section */}
            <DownloadApp />

            {/* 3. Reusable Global Bottom Components */}
            <Newsletter />
            <Footer />

        </div>
    );
}

export default Contact;